module.exports = __webpack_public_path__ + "static/media/files-and-folders.da9ec613.svg";